import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout.jsx";
import Login from "./sections/login";
import Register from "./sections/register";
import Dashboard from "./views/Dashboard";
import CompanySelection from "./sections/companySelection";
import AddProject from "./views/AddProject";
import AddVendor from "./views/Masters/AddVendor";
import ViewProjects from "./views/ViewProjects";
import ViewVendors from "./views/Masters/Views/ViewVendor";
import AddContractor from "./views/Masters/AddContractor";
import ViewContractor from "./views/Masters/Views/ViewContractor";
import AddEmployee from "./views/AddEmployee.js";
import ViewEmployees from "./views/ViewEmployees";
import EmployeeMenu from "./views/EmployeeMenu.js";
import ViewProjectCategories from "./views/Masters/Views/ViewProjectCategories";
import AddProjectCategory from "./views/Masters/AddProjectCategory";

// Vehicle Registration pages
import AddVehicleRegistration from "./views/AddVehicleRegistration";
import ViewVehicleRegistration from "./views/ViewVehicleRegistration";

import AddItems from "./views/Masters/AddItems.js";
import ViewItems from "./views/Masters/Views/ViewItems.js";
import AddStockIn from "./views/AddStockIn.js";
import ViewStockIn from "./views/ViewStockIn.js";
import AddStockIndent from "./views/AddStockIndent.js";
import ViewStockIndent from "./views/ViewStockIndent.js";
import AddVehicleHire from "./views/AddVehicleHire.js";
import ViewVehicleHire from "./views/ViewVehicleHire.js";
import AddVehicleInsurance from "./views/AddVehicleInsurance.js";
import ViewVehicleInsurance from "./views/ViewVehicleInsurance.js";
import AddVehicleReading from "./views/AddVehicleReading.js";
import ViewVehicleReading from "./views/ViewVehicleReading.js";
import AddVehicleService from "./views/AddVehicleService.js";
import ViewVehicleService from "./views/ViewVehicleService.js";
import AddVehicleTax from "./views/AddVehicleTax.js";
import ViewVehicleTax from "./views/ViewVehicleTax.js";
import AddVehicleTransfer from "./views/AddVehicleTransfer.js";
import ViewVehicleTransfer from "./views/ViewVehicleTransferRequest.js";
import AddVehicleType from "./views/Masters/AddVehicleType.js";
import ViewVehicleType from "./views/Masters/Views/ViewVehicleType.js";
import AddLocation from "./views/Masters/AddLocation.js";
import ViewLocation from "./views/Masters/Views/ViewLocation.js";
import AddProjectLocation from "./views/AddProjectLocation.js";
import ViewProjectLocation from "./views/ViewProjectLocation.js";
import AddProjectVehicle from "./views/AddProjectVehicle.js";
import ViewProjectVehicle from "./views/ViewProjectVehicle.js";
import AddStockout from "./views/AddStockOut.js";
import ViewStockout from "./views/ViewStockOut.js";
import AddStockReturn from "./views/AddStockReturn.js";
import ViewStockReturn from "./views/ViewStockReturn.js";
import AddStockTransfer from "./views/AddStockTransfer.js";
import ViewStockTransfer from "./views/ViewStockTransferDetails.js";
import ViewStockInD from "./views/ViewStockInDetails.js";
import ViewStockIndentD from "./views/ViewStockIndentDetails.js";
import ViewStockOutD from "./views/ViewStockOutDetails.js";
import ViewStockReturnD from "./views/ViewStockReturnDetails.js";
import AddStockSales from "./views/AddStockSales.js";
import ViewStockSales from "./views/ViewStockSales.js";
import ViewStockSalesDetails from "./views/ViewStockSalesDetails.js";
// import ViewStockTransferD from "./views/ViewStockTransferDetails.js";
import AddProjectStore from "./views/AddProjectStore.js";
import ViewProjectStore from "./views/ViewProjectStore.js";
import AddLeasetype from "./views/Masters/AddLeasetype.js";
import ViewLeasetype from "./views/Masters/Views/ViewLeasetype.js";
import AddUom from "./views/Masters/AddUom.js";
import ViewUom from "./views/Masters/Views/ViewUom.js";
import AddItemCategory from "./views/Masters/AddItemCategory.js";
import ViewItemCategory from "./views/Masters/Views/ViewItemCategory.js";
import AddProjectTeam from "./views/AddProjectTeam.js";
import ViewProjectTeam from "./views/ViewProjectTeam.js";
import ChangePassword from "./sections/changepassword.js";
import ViewDailyReport from "./views/ViewDailyReport.js";
import AddDailyReport from "./views/AddDailyReport.js";
import AddVendorCategory from "./views/Masters/AddVendorCategory.js";
import ViewVendorCategory from "./views/Masters/Views/ViewVendorCategory.js";
import ViewStore from "./views/Masters/Views/ViewStore.js";
import AddStore from "./views/Masters/AddStore.js";
import ViewCompany from "./views/Masters/Views/ViewCompany.js";
import AddCompany from "./views/Masters/AddCompany.js";
import ViewTransporter from "./views/Masters/Views/ViewTransporter.js";
import AddTransporter from "./views/Masters/AddTransporter.js";
import AddPettyCash from "./views/AddPettyCash.js";
import AddPayPettyCash from "./views/AddPayPettyCash.js";
import ViewPettyCash from "./views/ViewPettyCash.js";
import AddReadingType from "./views/Masters/AddReadingType.js";
import ViewReadingType from "./views/Masters/Views/ViewReadingType.js";
import ViewDailyFuelEntries from "./views/ViewDailyFuelEntries.js";
import AddDailyFuelEntry from "./views/AddDailyFuelEntry.js";
// import { AxiosHeaders } from "axios";
import ViewStockInfo from "./views/ViewStockInfo.js";
import ViewStockTransferMain from "./views/ViewStockTransfer.js";
import AddProjectItems from "./views/AddProjectItems.js";
import AddProjectEstimates from "./views/AddProjectEstimates.js";
import ViewProjectEstimates from "./views/ViewProjectEstimates.js";

import ReportRoutes from "./routes/ReportRoutes.js";

import AddWorkItem from "./views/Masters/AddWorkItem.js";
import ViewWorkItem from "./views/Masters/Views/ViewWorkItem.js";
import MasterRoutes from "./routes/MasterRoutes.js";
import EmployeeRoutes from "./routes/EmployeeRoutes.js";

import ReceiveStockTransferMain from "./views/ReceiveStockTransferMain.js";
import ReceiveStockTransfer from "./views/ReceiveStockTransfer.js";
import UnAuthorized from "./views/Unathorized.js";
import AddFuelPurchase from "./views/AddFuelPurchase";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/company-selection" element={<CompanySelection />} />
        <Route path="/cpnl/*" element={<Layout />}>

          {MasterRoutes}
          {/* Projects */}
          {EmployeeRoutes}


          {/*  Vehicle Registration */}
          <Route
            path="vehicles/add/:id?"
            element={<AddVehicleRegistration />}
          />
          <Route path="vehicles/view" element={<ViewVehicleRegistration />} />


          {/* Stock IN*/}
          <Route path="StockIn/add/:id?" element={<AddStockIn />} />
          <Route path="StockIn/view" element={<ViewStockIn />} />
          <Route path="StockInD/view/:id?" element={<ViewStockInD />} />
          {/* StockIndent*/}
          <Route path="StockIndent/add" element={<AddStockIndent />} />
          <Route path="StockIndent/add/:id" element={<AddStockIndent />} />
          <Route path="StockIndent/view" element={<ViewStockIndent />} />
          <Route path="StockIndentD/view/:id" element={<ViewStockIndentD />} />
          {/* Stock Out*/}
          <Route path="Stockout/add/:id?" element={<AddStockout />} />
          <Route path="Stockout/view" element={<ViewStockout />} />
          <Route path="StockOutD/view/:id?" element={<ViewStockOutD />} />
          {/* Stock Sales */}
          <Route path="StockSales/add/:id?" element={<AddStockSales />} />
          <Route path="StockSales/view" element={<ViewStockSales />} />
          <Route path="StockSalesD/view/:id?" element={<ViewStockSalesDetails />} />
          {/* Stock Return*/}
          <Route path="Stockreturn/add" element={<AddStockReturn />} />
          <Route path="Stockreturn/view" element={<ViewStockReturn />} />
          <Route path="StockReturnD/view" element={<ViewStockReturnD />} />
          <Route path="StockReturnD/view/:id" element={<ViewStockReturnD />} />
          {/* Stock Transfer */}
          <Route path="Stocktransfer/add/:id?" element={<AddStockTransfer />} />
          <Route path="Stocktransfer/view" element={<ViewStockTransferMain />} />
          <Route path="Stocktransfer/view/:id" element={<ViewStockTransfer />} />
          <Route path="Stocktransfer/receive" element={<ReceiveStockTransferMain />} />
          <Route path="Stocktransfer/receive/:id" element={<ReceiveStockTransfer />} />

          <Route path="Readingtype/add/:id?" element={<AddReadingType />} />
          <Route path="ReadingType/view" element={<ViewReadingType />} />

          {/* VehicleHire*/}
          <Route path="vehiclehire/add/:id?" element={<AddVehicleHire />} />
          <Route path="vehiclehire/view" element={<ViewVehicleHire />} />
          {/* VehicleInsurance*/}
          <Route
            path="vehicleinsurance/add/:id?"
            element={<AddVehicleInsurance />}
          />
          <Route
            path="vehicleinsurance/view"
            element={<ViewVehicleInsurance />}
          />
          {/* VehicleReading*/}
          <Route
            path="vehiclereading/add/:id?"
            element={<AddVehicleReading />}
          />
          <Route path="vehiclereading/view" element={<ViewVehicleReading />} />
          {/* VehicleService*/}
          <Route
            path="vehicleservice/add/:id?"
            element={<AddVehicleService />}
          />
          <Route path="vehicleservice/view" element={<ViewVehicleService />} />
          {/* VehicleTax*/}
          <Route path="vehicletax/add/:id?" element={<AddVehicleTax />} />
          <Route path="vehicletax/view" element={<ViewVehicleTax />} />
          {/* VehicleTransfer*/}
          <Route path="vehicletransfer/add/:id?" element={<AddVehicleTransfer />} />
          <Route
            path="vehicletransfer/view"
            element={<ViewVehicleTransfer />}
          />
          {/* VehicleType*/}
          <Route path="vehicletype/add/:id?" element={<AddVehicleType />} />
          <Route path="vehicletype/view" element={<ViewVehicleType />} />
          {/* Location*/}
          <Route path="location/add/:id?" element={<AddLocation />} />
          <Route path="location/view" element={<ViewLocation />} />
          {/* project Location*/}
          <Route path="projectlocation/add" element={<AddProjectLocation />} />
          <Route
            path="projectlocation/view"
            element={<ViewProjectLocation />}
          />
          {/* Project Vehicle*/}
          <Route path="projectvehicle/add" element={<AddProjectVehicle />} />
          <Route path="projectvehicle/view" element={<ViewProjectVehicle />} />

          {/* Store*/}
          <Route path="projectstore/add" element={<AddProjectStore />} />
          <Route path="projectstore/view" element={<ViewProjectStore />} />

          {/* Project Estimates */}
          <Route path="projectestimates/add/:id?" element={<AddProjectEstimates />} />
          <Route path="projectestimates/view" element={<ViewProjectEstimates />} />

          {/* Lease Type*/}
          <Route path="leasetype/view" element={<ViewLeasetype />} />
          <Route path="leasetype/add/:id?" element={<AddLeasetype />} />

          {/* Uom*/}
          <Route path="uom/add/:id?" element={<AddUom />} />
          <Route path="uom/view" element={<ViewUom />} />

          {/* Project Team*/}
          <Route path="projectteam/add" element={<AddProjectTeam />} />
          <Route path="projectteam/view" element={<ViewProjectTeam />} />

          <Route path="projectitem/add" element={<AddProjectItems />} />


          {/* Daily Report*/}
          <Route path="dailyreport/add/:id?" element={<AddDailyReport />} />
          <Route path="dailyreport/view" element={<ViewDailyReport />} />




          <Route path="dailyfuelentry/add/:id?" element={<AddDailyFuelEntry />} />
          <Route path="dailyfuelentry/view" element={<ViewDailyFuelEntries />} />

          <Route path="pettycash/add/:id?" element={<AddPettyCash />} />
          <Route path="pettycash/view" element={<ViewPettyCash />} />
          <Route path="stockinfo/view" element={<ViewStockInfo />} />
          <Route path="paypettycash/add/:id?" element={<AddPayPettyCash />} />
          <Route path="unauthorized" element={<UnAuthorized/>} />

          <Route path="fuelpurchase/add" element={<AddFuelPurchase />} />
          {ReportRoutes}     
        </Route>
        
      </Routes>
    </Router>
  );
}

export default App;
